<template>
  <div v-if="lookupsLoaded" class="pb-5 px-md-3">
    <ValidationObserver v-slot="{ invalid }" ref="formValidationObserver">
      <b-form @submit.prevent="SavePerson">
        <!--Title/Actions-->
        <div class="page-header">
          <div class="container d-flex justify-content-between p-0">
            <h3>
              <i class="fas fa-user-plus"></i>&nbsp;&nbsp;Users: {{personForEdit.firstName}} {{personForEdit.lastName}}
            </h3>
            <div class="d-flex align-items-center">
              <div v-if="personForEdit.id || personForEdit.isNew">
                <div>
                  <b-form-checkbox
                    v-model="personForEdit.isArchived"
                    name="check-button"
                    switch
                  ><span>Archive User</span></b-form-checkbox>
                </div>
              </div>
              <router-link class="ml-3 mr-1" title="Close" :to="{ name: 'People'}"><b-button variant="light" >Close</b-button></router-link>
              <b-button type="submit" variant="primary" :disabled="invalid">Save</b-button>
            </div>
          </div>
        </div>

        <!--Edit User-->
        <div v-if="personForEdit.id || personForEdit.isNew" class="container p-3 p-md-4 form-container">
          <label class="section-label">
            <i class="fas fa-info-circle"></i> User Details
          </label>
          <div class="form-group row">
            <div class="col-md-6 col-12">
              <label class="control-label">First Name</label>
              <ValidationProvider name="First Name" rules="required" v-slot="validation">
                <b-form-input
                  placeholder="First Name"
                  :state="spr2_getValidationState(validation)"
                  v-model="personForEdit.firstName"
                  aria-describedby="first-name-feedback"
                />
                <b-form-invalid-feedback id="first-name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
            <div class="col-md-6 col-12">
              <label class="control-label">Last Name</label>
              <ValidationProvider name="Last Name" rules="required" v-slot="validation">
                <b-form-input
                  placeholder="Last Name"
                  :state="spr2_getValidationState(validation)"
                  v-model="personForEdit.lastName"
                  name="Last Name"
                  aria-describedby="last-name-feedback"
                />
                <b-form-invalid-feedback id="last-name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md col-12">
              <label class="control-label">Phone #</label>
              <ValidationProvider
                name="Phone Number"
                rules="phoneNumber"
                v-slot="validation"
              >
                <b-form-input
                  placeholder="(555) 555-5555"
                  :state="spr2_getValidationState(validation)"
                  v-model="personForEdit.phoneNumber"
                  name="Phone Number"
                  aria-describedby="phone-number-feedback"
                />
                <b-form-invalid-feedback id="phone-number-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
            <div class="col-md col-12">
              <label class="control-label">Email Address</label>
              <ValidationProvider name="Email Address" rules="required|email" v-slot="validation">
                <b-form-input
                  placeholder="Email"
                  :state="spr2_getValidationState(validation)"
                  v-model="personForEdit.emailAddress"
                  name="Email Address"
                  aria-describedby="email-address-feedback"
                />
                <b-form-invalid-feedback id="email-address-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label class="control-label">Role</label>
              <ValidationProvider name="Role" rules="required" v-slot="validation">
                <b-form-select
                  :state="spr2_getValidationState(validation)"
                  :options="positionTypesOptions"
                  v-model="personForEdit.positionId"
                  aria-describedby="role-feedback">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Position</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="role-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <!--Subscriptions-->
          <!--
          <label class="section-label mt-5">
            <i class="fas fa-check-square"></i> Subscriptions
          </label>
          <div class="row form-group mb-3">
            <div class="col-12">
              <label class="control-label mb-0">Event Severity Subscription</label>
              <small class="d-block mb-2">Define event severity that will prompt a notification to you.</small>
              <b-form-select
                class="w-50"
                :options="[{ text: 'High', value: 1}, { text: 'High and Low', value: 0}, { text: 'None', value: 2}]"
                v-model="personForEdit.propertyEventSeverityLevel">
              </b-form-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label class="m-0">Event Subscriptions</label>
              <small class="d-block mb-2">Select event changes that will prompt a notification.</small>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-checkbox
                v-model="personForEdit.eventChangeSubscriptions.created"
              >Event Created</b-form-checkbox>
              <b-form-checkbox
                v-model="personForEdit.eventChangeSubscriptions.statusChanged"
              >Event Status Changed</b-form-checkbox>
              <b-form-checkbox
                v-model="personForEdit.eventChangeSubscriptions.pendingApproval"
              >Event Pending Approval</b-form-checkbox>
            </div>
          </div>
          -->
          <!--Properties-->
          <div class="row mt-5">
            <div class="col-md-7 col-12">
              <label class="section-label d-block mb-0">
                <i class="fas fa-home"></i> Properties
              </label>
              <small>Select properties to associate with this user</small>
            </div>
          </div>
          <div class="row no-gutters mt-2 rg-table-add">
            <div class="flex-grow-1">
              <b-form-select :disabled="personForEdit.allPropertiesAssociated" :options="propertiesOptions" v-model="selectedProperty">
                <template #first>
                  <b-form-select-option :value="null" disabled>Select a Property to Associate</b-form-select-option>
                </template>
              </b-form-select>
            </div>
            <div class="flex-shrink-1">
              <b-button
                variant="success"
                @click="addPropertyToList"
                :disabled="personForEdit.allPropertiesAssociated"
              >Add</b-button>
            </div>
          </div>
          <div>
            <b-table-simple bordered class="rg-table mb-5">
              <b-thead head-variant="dark">
                <b-tr>
                  <b-th>Name</b-th>
                  <b-th>Location</b-th>
                  <b-th class="text-center" style="width: 10%;">Remove</b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <b-tr v-for="prop in personAssociatedProperties" v-bind:key="prop.id">
                  <b-td>
                    <div>{{ prop.name }}</div>
                  </b-td>
                  <b-td>
                    <div>{{ prop.city }} {{ prop.state }}</div>
                  </b-td>
                  <b-td class="p-1 text-center">
                    <b-btn
                      class="mt-1"
                      variant="light"
                      @click="deletePropertyAssociation(prop.id)"
                      :disabled="personForEdit.allPropertiesAssociated"
                    >
                      <i class="fas fa-times"></i>
                    </b-btn>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>

          <!--Property-Groups-->
          <label class="section-label d-block mt-5 mb-0">
            <i class="fas fa-warehouse"></i> Property Groups
          </label>
          <small>Select property groups to associate with this user</small>
          <div class="row mt-2 no-gutters rg-table-add">
            <div class="flex-grow-1">
              <b-form-select
                :options="propertyGroupOptions"
                v-model="selectedPropertyGroup">
                  <template #first>
                  <b-form-select-option :value="null" disabled>Select a Property Group to Associate</b-form-select-option>
                  </template>
              </b-form-select>
            </div>
            <div class="flex-shrink-1">
              <b-button variant="success" @click="addPropertyGroupToList">Add</b-button>
            </div>
          </div>
          <div>
            <b-table-simple bordered class="rg-table mb-5">
              <b-thead head-variant="dark">
                <b-tr>
                  <b-th>Name</b-th>
                  <b-th class="text-center" style="width: 10%;">Remove</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="prop in personAssociatedPropertyGroups" v-bind:key="prop.id">
                  <b-td>
                    <div>{{ prop.name }}</div>
                  </b-td>
                  <b-td class="p-1 text-center">
                    <b-btn
                      class="mt-1"
                      variant="light"
                      @click="deletePropertyGroupAssociation(prop.id)"
                      :disabled="personForEdit.allPropertiesAssociated"
                    >
                      <i class="fas fa-times"></i>
                    </b-btn>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../../mixins/Spr2SharedFunctions'
export default {
  mixins: [spr2Validation],
  data () {
    return {
      personForEdit: {
        eventSubscriptionTypes: [],
        propertyAssociations: [],
        propertyGroupAssociations: []
      },
      selectedProperty: null,
      selectedPropertyGroup: null,
      companyProperties: null,
      propertyGroups: [],
      lookupsLoaded: false,
      positionTypes: [],
      personAssociatedProperties: [],
      personAssociatedPropertyGroups: []
    }
  },
  created () {
    this.personForEdit = {
      isNew: true,
      firstName: null,
      lastName: null,
      id: null,
      positionId: null,
      propertyAssociations: [],
      eventSubscriptionTypes: [],
      propertyGroupAssociations: [],
      eventChangeSubscriptions: {
        created: false,
        statusChanged: false,
        pendingApproval: false
      },
      propertyEventSeverityLevel: 2
    }
    Promise.all([this.doLoadCompanyPerson(), this.doLoadProperties(), this.doLoadPropertyGroups(), this.doLoadPositionTypes()]).then(() => { this.lookupsLoaded = true })
  },
  computed: {
    companyPersonId () {
      return this.$route.params.id === 'new' ? null : this.$route.params.id
    },
    allCompanyProperties () {
      return this.companyProperties
    },
    propertiesOptions () {
      var properties = this.allCompanyProperties
      var results = properties.map((val, index) => {
        return { text: val.name, value: val.id }
      })
      console.log(
        'Returning Property Options: ' + JSON.stringify(results, null, 2)
      )
      return results
    },
    propertyGroupOptions () {
      var propertyGroups = this.propertyGroups
      var results = propertyGroups.map((val, index) => {
        return { text: val.name, value: val.id }
      })
      console.log(
        'Returning Property Options: ' + JSON.stringify(results, null, 2)
      )
      return results
    },
    positionTypesOptions () {
      var types = this.positionTypes
      var results = types.filter(ft => ft.active).map((val, index) => {
        return { text: val.name, value: val.id }
      })
      console.log(
        'Returning Position Types Options: ' + JSON.stringify(results, null, 2)
      )
      return results
    }
  },
  methods: {
    ...mapActions('company', [
      'savePerson',
      'getPersonForEdit',
      'getPositionTypes',
      'getProperties',
      'getPropertyGroups'
    ]),
    doLoadCompanyPerson () {
      if (!this.companyPersonId) {
        return new Promise(resolve => { resolve() })
      } else {
        return this.getPersonForEdit(this.companyPersonId).then(r => {
          this.personForEdit = r.data.person
          this.personAssociatedProperties = r.data.propertyAssociations
          this.personAssociatedPropertyGroups = r.data.propertyGroupAssociations
        })
      }
    },
    addPropertyToList () {
      console.log('looking up property: ' + this.selectedProperty)
      var foundProperty = this.lookupProperty(this.selectedProperty)
      console.log('found: ' + foundProperty.name)
      if (
        this.personForEdit.propertyAssociations.find(
          p => p === this.selectedProperty
        ) != null
      ) {
        return
      }
      this.personForEdit.propertyAssociations.push(foundProperty.id)
      this.personAssociatedProperties.push({id: foundProperty.id, city: foundProperty.address.city, name: foundProperty.name, currentUserAssociated: true, state: foundProperty.address.state})
    },
    addPropertyGroupToList () {
      console.log('looking up property: ' + this.selectedPropertyGroup)
      var foundPropertyGroup = this.lookupPropertyGroup(
        this.selectedPropertyGroup
      )
      console.log('found: ' + foundPropertyGroup.name)
      if (
        this.personForEdit.propertyGroupAssociations.find(
          p => p === this.selectedPropertyGroup
        ) != null
      ) {
        return
      }
      this.personForEdit.propertyGroupAssociations.push(foundPropertyGroup.id)
      this.personAssociatedPropertyGroups.push({id: foundPropertyGroup.id, name: foundPropertyGroup.name, currentUserAssociated: true})
    },
    deletePropertyAssociation (id) {
      console.log('deleting property association: ' + id)
      this.personForEdit.propertyAssociations = this.personForEdit.propertyAssociations.filter(
        (p, i, arr) => p !== id
      )
      this.personAssociatedProperties = this.personAssociatedProperties.filter(
        (p, i, arr) => p.id !== id
      )
    },
    deletePropertyGroupAssociation (id) {
      console.log('deleting property Group association: ' + id)
      this.personForEdit.propertyGroupAssociations = this.personForEdit.propertyGroupAssociations.filter(
        (p, i, arr) => p !== id
      )
      this.personAssociatedPropertyGroups = this.personAssociatedPropertyGroups.filter(
        (p, i, arr) => p.id !== id
      )
    },
    lookupProperty (id) {
      return this.allCompanyProperties.find(p => p.id === id)
    },
    lookupPropertyGroup (id) {
      return this.propertyGroups.find(p => p.id === id)
    },
    async SavePerson () {
      const newPerson = this.personForEdit
      if (newPerson.id === 'new') {
        newPerson.id = null
      }
      return this.savePerson(newPerson).then((result) => {
        if (result.success) {
          this.$toasted.show('Person Saved.', { duration: 4000 })
          this.$store.dispatch('loadCompanyPermissionsForUser')
          this.$router.push({name: 'People'})
        } else {
          this.$toasted.error(result.failureReason, { duration: 4000 })
        }
      })
    },
    async doLoadProperties () {
      return this.getProperties().then(r => {
        this.companyProperties = r.data.properties
      })
    },
    async doLoadPropertyGroups () {
      return this.getPropertyGroups().then(r => {
        this.propertyGroups = r.data.propertyGroups
      })
    },
    async doLoadPositionTypes () {
      return this.getPositionTypes().then(r => {
        this.positionTypes = r.data.types
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/setup/CompanyPerson.vue